export const INTRO_TEXT =
  "With 9+ years as a full stack developer, I’ve voyaged through diverse technologies, including Android, Flutter, and ReactJS. Join me in exploring my digital odyssey.";
export const PROJECTS_DATA = [
  {
    title: "Agricare",
    period: "Jan 2024 - Mar 2024",
    description: "a comprehensive solution for managing agricultural trials.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/0375460d-d9a0-4da9-baae-e3ee4780d819",
  },
  {
    title: "Home Plus",
    period: "Jun 2024 - Jul 2024",
    description:
      "All-in-one app designed to enhance your sales and after-sales experience.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/64857c47-8f26-4784-bfe5-df83b216998a",
  },
  {
    title: "Quiz - Capitals and Countries Test",
    period: "Apr 2020 - Jun 2021",
    description: "Quiz game I programmed in 2021.",

    image:
      "https://mostaql.hsoubcdn.com/uploads/portfolios/484931/62f423c2692a5/Screen-Shot-2022-08-10-at-10.28.59-PM.png",
  },
  {
    title: "Crypto data & news app",
    period: "Aug 2021 - Jan 2023",
    description:
      "The first digital currency application in the Arab world, I programmed it in 2021.",
    image:
      "https://mostaql.hsoubcdn.com/uploads/portfolios/484931/62f3de9e7b877/Screen-Shot-2022-08-10-at-5.35.08-PM.png",
  },

  // Add more project entries as needed
];
export const ALL_PROJECTS_DATA = [
  {
    title: "Agricare",
    period: "Jan 2024 - Mar 2024",
    description: "a comprehensive solution for managing agricultural trials.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/0375460d-d9a0-4da9-baae-e3ee4780d819",
  },
  {
    title: "Home Plus",
    period: "Jun 2024 - Jul 2024",
    description:
      "All-in-one app designed to enhance your sales and after-sales experience.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/64857c47-8f26-4784-bfe5-df83b216998a",
  },
  {
    title: "Crypto data & news app",
    period: "Aug 2021 - Jan 2023",
    description:
      "The first digital currency application in the Arab world, I programmed it in 2021.",
    image:
      "https://mostaql.hsoubcdn.com/uploads/portfolios/484931/62f3de9e7b877/Screen-Shot-2022-08-10-at-5.35.08-PM.png",
  },
  {
    title: "Quiz - Capitals and Countries Test",
    period: "Apr 2020 - Jun 2021",
    description: "Quiz game I programmed in 2021.",

    image:
      "https://mostaql.hsoubcdn.com/uploads/portfolios/484931/62f423c2692a5/Screen-Shot-2022-08-10-at-10.28.59-PM.png",
  },
  {
    title: "Medical Files Creator",
    period: "Jun 2020 - Jul 2020",
    description: "Doc Generator application for creating medical files.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/ad128df8-546c-4de1-a138-8f7079dc4520",
  },
  {
    title: "Challange castle",
    period: "Sep 2018 - Dec 2018",
    description:
      "Challenge Castle game, various cultural questions in an entertaining form.",
    image:
      "https://www.upwork.com/att/download/portfolio/persons/uid/1257874919280738304/profile/projects/files/2c28e772-a25d-419c-80a7-dc7e4b30dc85",
  },
  // Add more project entries as needed
];
export const SKILLS_DATA = [
  {
    name: "Flutter",
    desc: "Framework",
    logo: "https://web-strapi.mrmilu.com/uploads/flutter_logo_470e9f7491.png",
  },
  {
    name: "Android",
    desc: "Framework",
    logo: "https://seeklogo.com/images/A/android-logo-9E4539A7DE-seeklogo.com.png",
  },
  {
    name: "ReactJs",
    desc: "Library",
    logo: "https://cdn1.iconfinder.com/data/icons/programing-development-8/24/react_logo-512.png",
  },
  {
    name: "Dart",
    desc: "Language",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Dart_programming_language_logo_icon.svg/2048px-Dart_programming_language_logo_icon.svg.png",
  },
  {
    name: "Java",
    desc: "Language",
    logo: "https://cdn-icons-png.flaticon.com/512/152/152760.png",
  },
  {
    name: "JavaScript",
    desc: "Language",
    logo: "https://pnggallery.com/wp-content/uploads/javascript-logo-01.png",
  },
  {
    name: "Firebase",
    desc: "Auth, DB, FCM ..etc ",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-YBGqdi62T3S6mpTpVrYj7_sTM5vqBs4Cbw&s",
  },
  {
    name: "API Integration",
    desc: "Databases",
    logo: "https://cdn-icons-png.flaticon.com/512/2165/2165004.png",
  },
  {
    name: "SQL",
    desc: "Databases",
    logo: "https://cdn-icons-png.flaticon.com/512/2772/2772165.png",
  },
  {
    name: "GIT & Github",
    desc: "Version Control",
    logo: "https://git-scm.com/images/logos/downloads/Git-Icon-Black.png",
  },
  {
    name: "Responsive UI",
    desc: "User Interface",
    logo: "https://www.freeiconspng.com/uploads/responsive-icon-15.png",
  },
  {
    name: "Problem Solving",
    desc: "Soft Skills",
    logo: "https://icon-library.com/images/problem-solving-icon/problem-solving-icon-21.jpg",
  },
];
export const WORK_HISTORY_DATA = [
  {
    period: "2015 – 2019",
    title: "Android Developer",
    subtitle: "Company ABC",
    description:
      "Venturing into the dynamic realm of Android development, I embarked on a transformative journey as a freelance developer from 2015 to 2019. Over this expansive period, I had the privilege of immersing myself in a diverse array of local projects. From meticulously crafting engaging user interfaces that captivated users to seamlessly integrating complex functionalities, my role as an Android developer provided me with the invaluable opportunity to translate creative ideas into tangible and immersive digital experiences.",
  },
  {
    period: "2019 – 2020",
    title: "Web Development",
    subtitle: "Company ABC",
    description:
      "As a freelance developer , I focused on harnessing the power of ReactJS, along with the versatile Ant Design framework, to craft visually engaging and responsive web applications. During this period, I specialized in creating data-rich dashboards that provided clients with real-time insights, leveraging various databases to ensure seamless data integration. My freelance experience allowed me to continuously innovate and deliver high-quality solutions to clients while honing my skills as an independent developer.",
  },
  {
    period: "2020 - 2021",
    title: "Full-stack Developer",
    subtitle: "Company ABC",
    description:
      "As a freelance full-stack developer from 2020 to 2021, I dedicated myself to mastering Android and React technologies, leveraging my expertise to shape the landscape of medical software and crypto applications. This timeframe epitomized my unwavering commitment to driving innovation and progress in these essential sectors.",
  },
  {
    period: "2021 - 2023",
    title: "Senior Developer",
    subtitle: "Company ABC",
    description:
      "From 2021 to 2023, I had the honor of serving as a senior developer at Amwal Network, the leading Arab crypto news company of its time. During this tenure, I applied my expertise in Android, ReactJS, and React Native to drive innovation and excellence in the development of cutting-edge digital solutions.",
  },
  {
    period: "2023 - Present",
    title: "Full-stack Developer",
    subtitle: "Company ABC",
    description:
      "From 2023 onwards, I’ve thrived as a freelance full-stack developer, specializing in Flutter and applying my extensive expertise in Android, ReactJS, React Native, and various other technologies. My commitment to innovation and excellence in digital development remains unwavering.",
  },
  // Add more work history entries as needed
];
export const WORK_HISTORY_INTRO =
  " Embarking on a journey through time, my work history reflects the evolution of my skills and experiences. Each chapter represents a unique opportunity for growth and innovation. Let’s delve into the milestones that have shaped my path as a developer.";
export const SERVICES_DATA = [
  {
    title: "Flutter Cross Platform App",
    subtitle: "Build Once, Deploy Anywhere",
    description:
      "Create beautiful and high-performance mobile applications that run on both iOS and Android using Flutter, a versatile and open-source UI software development toolkit.",
    image:
      "https://www.dionach.com/wp-content/uploads/2017/11/android-vs-ios.png",
    url: "https://www.fiverr.com/boubakeur_obr/build-ios-and-android-mobile-app-using-flutter-and-firebase",
  },
  /*
  {
    title: "React Web App",
    subtitle: "Responsive Web Solutions",
    description:
      "Develop dynamic and user-friendly web applications using React, a popular JavaScript library for building user interfaces. Build modern, single-page applications with ease.",
    image: "https://www.noblewebstudio.com/img/website-development.png",
  },
  {
    title: "Dashboard",
    subtitle: "Data Visualization and Analytics",
    description:
      "Design and implement powerful dashboards to visualize complex data sets. Provide insights and analytics to users with interactive and informative dashboards tailored to your business needs.",
        url: "",

      image:
      "https://cdn.dribbble.com/userupload/5285904/file/original-1376e8dd6b81f7725e57e11bb91f7fd7.png?resize=400x300&vertical=center",
  },
  */
  {
    title: "Landing Page",
    subtitle: "Captivating First Impressions",
    description:
      "Craft visually appealing and effective landing pages to make a lasting impression on your audience. Optimize user engagement and conversion rates with compelling and responsive landing pages. ",
    url: "https://www.fiverr.com/boubakeur_obr/build-a-custom-landing-page-using-reactjs",
    image:
      "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/356581711/original/ea117003b9d1a210207357a8df0a2650b15d4a12/build-a-custom-landing-page-using-reactjs.png",
  },
  {
    title: "Android Native App",
    subtitle: "Native Experience on Android Devices",
    description:
      "Develop feature-rich and native Android applications using Java. Leverage the Android platform's capabilities to deliver high-performance and seamless user experiences on a wide range of devices.",
    url: "https://www.fiverr.com/boubakeur_obr/develop-or-update-an-android-app",

    image:
      "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/356520952/original/6cafd08ab9c78eecb17b66d85eb9699337efdb47/develop-or-update-an-android-app.png",
  },
  {
    title: "Desktop App",
    subtitle: "Cross-Platform Desktop Solutions",
    description:
      "Create cross-platform desktop applications with Flutter. Utilize a single codebase to deliver desktop apps for Windows, macOS, and Linux. Provide a consistent user experience across different operating systems.",
    url: "",

    image:
      "https://www.muvi.com/wp-content/uploads/2023/03/Enriched-with-Features.webp",
  },
];
export const ALL_SERVICES_DATA = [
  {
    title: "Flutter Cross Platform App",
    subtitle: "Build Once, Deploy Anywhere",
    description:
      "Create beautiful and high-performance mobile applications that run on both iOS and Android using Flutter, a versatile and open-source UI software development toolkit.",
    image:
      "https://www.dionach.com/wp-content/uploads/2017/11/android-vs-ios.png",
    url: "https://www.fiverr.com/boubakeur_obr/build-ios-and-android-mobile-app-using-flutter-and-firebase",
  },

  {
    title: "Landing Page",
    subtitle: "Captivating First Impressions",
    description:
      "Craft visually appealing and effective landing pages to make a lasting impression on your audience. Optimize user engagement and conversion rates with compelling and responsive landing pages. ",
    url: "https://www.fiverr.com/boubakeur_obr/build-a-custom-landing-page-using-reactjs",
    image:
      "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/356581711/original/ea117003b9d1a210207357a8df0a2650b15d4a12/build-a-custom-landing-page-using-reactjs.png",
  },
  {
    title: "Android Native App",
    subtitle: "Native Experience on Android Devices",
    description:
      "Develop feature-rich and native Android applications using Java. Leverage the Android platform's capabilities to deliver high-performance and seamless user experiences on a wide range of devices.",
    url: "https://www.fiverr.com/boubakeur_obr/develop-or-update-an-android-app",

    image:
      "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/356520952/original/6cafd08ab9c78eecb17b66d85eb9699337efdb47/develop-or-update-an-android-app.png",
  },
  {
    title: "Desktop App",
    subtitle: "Cross-Platform Desktop Solutions",
    description:
      "Create cross-platform desktop applications with Flutter. Utilize a single codebase to deliver desktop apps for Windows, macOS, and Linux. Provide a consistent user experience across different operating systems.",
    url: "",

    image:
      "https://www.muvi.com/wp-content/uploads/2023/03/Enriched-with-Features.webp",
  },
  {
    title: "React Web App",
    subtitle: "Responsive Web Solutions",
    description:
      "Develop dynamic and user-friendly web applications using React, a popular JavaScript library for building user interfaces. Build modern, single-page applications with ease.",
    image: "https://www.noblewebstudio.com/img/website-development.png",
  },
  {
    title: "Dashboard",
    subtitle: "Data Visualization and Analytics",
    description:
      "Design and implement powerful dashboards to visualize complex data sets. Provide insights and analytics to users with interactive and informative dashboards tailored to your business needs.",
    url: "",

    image:
      "https://cdn.dribbble.com/userupload/5285904/file/original-1376e8dd6b81f7725e57e11bb91f7fd7.png?resize=400x300&vertical=center",
  },
];
export const TITLE6 = "";
export const TITLE7 = "";
